module.exports = __webpack_public_path__ + "static/media/star.d88db0fb.png";